import DownloadsTable from "./DownloadsTable";

export default DownloadsTable;
